/**
 * @generated SignedSource<<eb32ad0218f1234eb10ceea6afef44da>>
 * @relayHash afc6cf650d76ec77ae6c4e967b74c46b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdatePriorityFieldInput = {
  id: string;
  operation: JiraPriorityFieldOperationInput;
};
export type JiraPriorityFieldOperationInput = {
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
  priority?: string | null | undefined;
};
export type priority_issueFieldPriority_PriorityField_Mutation$variables = {
  input: JiraUpdatePriorityFieldInput;
};
export type priority_issueFieldPriority_PriorityField_Mutation$data = {
  readonly jira: {
    readonly updatePriorityField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly priority: {
          readonly iconUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type priority_issueFieldPriority_PriorityField_Mutation$rawResponse = {
  readonly jira: {
    readonly updatePriorityField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly priority: {
          readonly iconUrl: AGG$URL | null | undefined;
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type priority_issueFieldPriority_PriorityField_Mutation = {
  rawResponse: priority_issueFieldPriority_PriorityField_Mutation$rawResponse;
  response: priority_issueFieldPriority_PriorityField_Mutation$data;
  variables: priority_issueFieldPriority_PriorityField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "concreteType": "JiraPriority",
  "kind": "LinkedField",
  "name": "priority",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "ScalarField",
      "name": "iconUrl"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "priority_issueFieldPriority_PriorityField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraPriorityFieldPayload",
            "kind": "LinkedField",
            "name": "updatePriorityField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraPriorityField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "priority_issueFieldPriority_PriorityField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraPriorityFieldPayload",
            "kind": "LinkedField",
            "name": "updatePriorityField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraPriorityField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v4/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "e85774926933c84980d45da86dae031162c7414ce78af28e54effc3c4a04a2fa",
    "metadata": {},
    "name": "priority_issueFieldPriority_PriorityField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e0f2a7894e2dd7cf045761e8324c5c39";

export default node;
